import { get } from 'lodash'
import { UrlQueryParamsType } from '../types/StorePageType'

export const getQueryParamsAsObject = (url: string): UrlQueryParamsType => {
  let urlObject = null

  try {
    urlObject = new URL(url)
  } catch (error) {
    return {}
  }

  // if there are no search params we return an empty object
  if (!urlObject || !urlObject.search) {
    return {}
  }

  // we get the search params from the url
  const queryParamsObject = new URLSearchParams(urlObject.search)

  let paramsObject = {}
  for (const pair of queryParamsObject.entries()) {
    if (pair[1] === 'true') {
      paramsObject = {
        ...paramsObject,
        [pair[0]]: true
      }
    } else if (pair[0] === 'affiliateLink') {
      // temporary property for affiliate link frontend fix story: DTSHOPATMS-1503
      // if the property is affiliateLink we pass the value as is since
      // URLSearchParams already decode the first part before the turl
      // and we need turl encoded
      paramsObject = {
        ...paramsObject,
        [pair[0]]: pair[1]
      }
    } else {
      paramsObject = {
        ...paramsObject,
        [pair[0]]: decodeURIComponent(pair[1])
      }
    }
  }
  return {
    type: get(paramsObject, 'type'),
    isModalOpen: get(paramsObject, 'isModalOpen', false),
    offerType: get(paramsObject, 'offerType'),
    offerId: get(paramsObject, 'offerId'),
    affiliateLink: get(paramsObject, 'affiliateLink') // temporary property for affiliate link frontend fix story: DTSHOPATMS-1503
  }
}
